import { render, staticRenderFns } from "./BulkAddProductsComponent.vue?vue&type=template&id=24da08c6&"
import script from "./BulkAddProductsComponent.vue?vue&type=script&lang=js&"
export * from "./BulkAddProductsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports